<template>
  <div :class="{ 'd-inline-flex rounded-circle': background }">
    <a v-if="isHomePage" :href="getApUrl" class="w-100">
      <img :src="logoImage" alt="Logo Akademia Przyszłości" class="position-relative" />
    </a>
    <router-link
      v-else
      :to="{ name: 'Home' }"
      custom
      v-slot="{ href, navigate }"
      class="w-100 router-link"
    >
      <a :href="href" @click="navigate" :class="{ 'd-inline-flex rounded-circle': background }">
        <img :src="logoImage" alt="Logo Akademia Przyszłości" class="position-relative" />
      </a>
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'

type Props = {
  file?: string
  background?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  file: 'logo.svg',
  background: false
})

const getApUrl = ref<string>(
  import.meta.env.VITE_APP_AP_URL ?? 'https://akademiaprzyszlosci.org.pl'
)

const route = useRoute()

const isHomePage = computed<boolean>(() => route.name === 'Home')

const logoImage = computed<string>(
  () => new URL(`/src/assets/svg/${props.file}`, import.meta.url).href
)
</script>
